import { Module } from "wrapper6";
import Glide from '@glidejs/glide';
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";
import { debounce } from '../utils/_debounce';

var $ = jQuery;

export default class MobileSlider extends Module {

	ready(app) {

	    window.glide_remount = this.reMount.bind(this);

        const SLIDER_CONTAINERS = document.querySelectorAll('.mobile-slider');
        this.sliders = [];

        if (SLIDER_CONTAINERS.length > 0) {

            this.mounted = [];

            for (let i = 0; i < SLIDER_CONTAINERS.length; i++) {

                const SLIDER_CONTAINER = SLIDER_CONTAINERS[i];
                const GLIDE = SLIDER_CONTAINER.querySelector('.glide');
                const LOADER = SLIDER_CONTAINER.querySelector('.loader-overlay');

                this.mounted.push(false);

                if (GLIDE) {

                    // setup slider
                    let SLIDER = new Glide(GLIDE, {
                        type: 'slider', // has to be slider
                        startAt: 0,
                        perView: 1,
                        gap: 15,
                        animationDuration: 800,
                        peek: {
                            after: 70,
                            before: 0
                        },
                        breakpoints: {
                            450: {
                                peek: {
                                    after: 40,
                                    before: 0
                                }
                            },
                            350: {
                                peek: {
                                    after: 0,
                                    before: 0
                                }
                            }
                        },
                        rewind: false
                    });

                    // Initialize
                    this.sliders.push(SLIDER);
                    this.initializeSlider(SLIDER, LOADER, i);
                    window.addEventListener('resize', debounce(() => { this.initializeSlider(SLIDER, LOADER, i) }, 300));
                }
            }
        }
    }

    initializeSlider(SLIDER, LOADER, INDEX) {

        // addClass(LOADER, 'show');
        // setTimeout(() => {
        //     removeClass(LOADER, 'show');
        // }, 300);

        if (this.getPageWidth() <= 580) {

            if (!this.mounted[INDEX]) {

                // Mount slider
                SLIDER.mount();
    
                this.mounted[INDEX] = true;
            }

        } else {

            if (this.mounted[INDEX]) {
                
                // Destroy
                SLIDER.destroy();
    
                this.mounted[INDEX] = false;
            }
        }
    }

    getPageWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    reMount(){
	    let l = this.sliders.length;
	    for (let i = 0; i < l; i++){
            if (this.mounted[i]) {
                this.sliders[i].mount();
            }
        }
    }
}